import { PasswordBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerResetPasswordStore } from '../state/useBrokerResetPasswordStore';

interface ConfirmNewPasswordTextBoxProps {
    required?: boolean;
}

export const ConfirmNewPasswordTextBox: React.FC<ConfirmNewPasswordTextBoxProps> = ({ required = false }) => {
    const isMobile = isMobileScreen();
    const label = 'Confirm New Password';
    const value = useBrokerResetPasswordStore((s) => s.passwordResetInfo.confirmNewPassword);
    const setValue = useBrokerResetPasswordStore((s) => s.set_confirmNewPassword);

    return (
        <>
            <PasswordBox
                id='confirmNewPasswordBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={required}
                width={isMobile ? '100%' : 'auto'}
            />
        </>
    );
};
